import styled from "styled-components";
export const LoaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100vh;
  align-items: center;
  justify-content: center;
  text-align: center;
`;
export const SmallContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
`;
export const ErrorTextContainer = styled.div`
  padding: 20px;
`;
